import { useQuery } from '@tanstack/react-query';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

/**
 * Fetch recipes with pagination and search
 * @returns {object}
 */
function useTeam({ level = null }) {
	const { isPending, isError, data, error } = useQuery({
		queryKey: ['categories'],
		queryFn: async () => {
			/* Add the nonce as middleware. This automatically adds the `X-WP-Nonce` header to requests. */
			apiFetch.use(
				apiFetch.createNonceMiddleware(window.visitEduSettings.nonce)
			);

			const path = addQueryArgs('/wp/v2/team', {
				...(level && { level: level }),
			});

			const response = await apiFetch({
				path: path,
				parse: false,
			});

			const items = await response.json();

			return items;
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
	};
}

export { useTeam };
